import React, { useEffect, useState } from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { UserManagementAction } from "../../../../../actions";
import { TYPES } from "../../../../../constants/accounting";
import { getUserFullNameWithEmptyState } from "../../../../../assets/getUserIdentification";
import { FullScreenLoading } from "../../../../../components/loading";
import ErrorHandle from "../../../../../components/error/mainError";
import { eliminateLastEmptyFields } from "../../../../../assets/accountingCode";
import {
  CUSTODIAN_FINANCIAL_SYSTEM_ACCOUNTING_HINT,
  CUSTODIAN_SUB_SYSTEM_ACCOUNTING_HINT
} from "../../../../../constants/otherTexts";
import { BorderedSection, TextInfoItem, Wrapper } from "../../../style";
import AccountingCode from "../../../../../projectSpecificComponents/accountingCode/form";
import ExpandedHeader from "../../../../../layouts/components/expandedHeader";
import Button from "../../../../../components/button";
import { StyledFixedRowButton } from "../../../../../assets/globalStyles/styledFixedButton";
import SingleAccountingCode from "../../../../../projectSpecificComponents/singleAccountingCode";

const SERIAL_ACCOUNTING_CODES = "serial_accounting_codes";
const SINGLE_ACCOUNTING_CODE = "single_accounting_code";

const Form = props => {
  const {
    history,
    processing,
    initialize,
    change,
    handleSubmit,
    editAccountingCodes,
    getAccountingCodes,
    data,
    loading,
    showError
  } = props;
  const linkState = history.location.state;
  const projectUser = linkState ? linkState.projectUser : {};
  const getRequest = () => {
    getAccountingCodes({
      project_user_id: projectUser.id
    });
  };
  useEffect(() => {
    getRequest();
  }, []);

  const [errors, setErrors] = useState({
    [SERIAL_ACCOUNTING_CODES]: [],
    [SINGLE_ACCOUNTING_CODE]: []
  });
  useEffect(() => {
    if (data) {
      initialize({
        [SERIAL_ACCOUNTING_CODES]: data[SERIAL_ACCOUNTING_CODES],
        [SINGLE_ACCOUNTING_CODE]: data[SINGLE_ACCOUNTING_CODE]
      });
    }
  }, [data]);
  const finalNormalizer = (postData, type) => {
    switch (type) {
      case SERIAL_ACCOUNTING_CODES:
        let tempData = postData && eliminateLastEmptyFields(postData);
        return (
          tempData &&
          tempData.map((obj, index) => {
            return {
              ...obj,
              type: obj.code ? TYPES.CONSTANT : TYPES.EMPTY,
              level: index + 1
            };
          })
        );
      case SINGLE_ACCOUNTING_CODE:
        return postData ? postData.code : null;
    }
  };
  const initialNormalizer = (receivedData, type) => {
    if (type === SINGLE_ACCOUNTING_CODE) {
      return receivedData ? [{ code: receivedData }] : "";
    }
  };
  const submit = values => {
    let accountingErrors = [],
      custodianError = [];
    if (
      accountingErrors.filter(err => !!err).length <= 0 &&
      custodianError.filter(err => !!err).length <= 0
    ) {
      const postData = {
        project_user_id: projectUser.id,
        [SERIAL_ACCOUNTING_CODES]: finalNormalizer(
          values[SERIAL_ACCOUNTING_CODES],
          SERIAL_ACCOUNTING_CODES
        ),
        [SINGLE_ACCOUNTING_CODE]: finalNormalizer(
          values[SINGLE_ACCOUNTING_CODE],
          SINGLE_ACCOUNTING_CODE
        )
      };
      editAccountingCodes(postData);
    } else {
      const updatedErrors = {
        [SERIAL_ACCOUNTING_CODES]: accountingErrors,
        [SINGLE_ACCOUNTING_CODE]: custodianError
      };
      setErrors(updatedErrors);
    }
  };
  return (
    <React.Fragment>
      <ExpandedHeader title="ویرایش کد حسابداری" />
      <Wrapper>
        {loading && <FullScreenLoading />}
        {data && !loading && (
          <React.Fragment>
            <BorderedSection>
              <TextInfoItem>
                <div className="label">نام شرکت:</div>
                <div className="value">{data.project && data.project.name}</div>
              </TextInfoItem>
              <TextInfoItem>
                <div className="label">نام کاربر:</div>
                <div className="value ellipsis">
                  {getUserFullNameWithEmptyState(data.user)}
                </div>
              </TextInfoItem>
              <TextInfoItem>
                <div className="label">شماره همراه:</div>
                <div className="value">
                  {" "}
                  {data.user && data.user.phone_number}
                </div>
              </TextInfoItem>
              <TextInfoItem>
                <div className="label">تیم تنخواه‌داری:</div>
                <div className="value">{data.team && data.team.name}</div>
              </TextInfoItem>
            </BorderedSection>
            <form onSubmit={handleSubmit(submit)}>
              <FieldArray
                name={SERIAL_ACCOUNTING_CODES}
                title={`کد حسابداری تنخواه‌دار در سیستم مالی`}
                component={AccountingCode}
                mainFieldType="text"
                updateErrors={_errors =>
                  setErrors({ ...errors, [SERIAL_ACCOUNTING_CODES]: _errors })
                }
                formErrors={errors[SERIAL_ACCOUNTING_CODES]}
                change={(data, index, field = null) => {
                  if (field) {
                    change(
                      `${SERIAL_ACCOUNTING_CODES}[${index}][${field}]`,
                      data
                    );
                  }
                }}
                infoText={CUSTODIAN_FINANCIAL_SYSTEM_ACCOUNTING_HINT}
              />
              <Field
                name={SINGLE_ACCOUNTING_CODE}
                title={`کد تنخواه‌دار در زیر سیستم`}
                component={SingleAccountingCode}
                mainFieldType="select"
                change={data => {
                  change(SINGLE_ACCOUNTING_CODE, data);
                }}
                infoText={CUSTODIAN_SUB_SYSTEM_ACCOUNTING_HINT}
              />
              <StyledFixedRowButton>
                <div className="right-part">
                  <Button type="submit" btn="primary" loading={processing}>
                    ذخیره
                  </Button>
                </div>
                <Button
                  btn="ghost"
                  onClick={e => {
                    e.preventDefault();
                    history.goBack();
                  }}
                >
                  انصراف
                </Button>
              </StyledFixedRowButton>
            </form>
          </React.Fragment>
        )}
        <ErrorHandle message={showError} request={getRequest} />
      </Wrapper>
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    processing: store.UserManagement.userAccountingCodeProcessing,
    loading: store.UserManagement.userAccountingCodeLoading,
    data: store.UserManagement.userAccountingCodeData,
    showError: store.UserManagement.userAccountingCodeError
  };
};
const mapDispatchToProps = dispatch => {
  return {
    editAccountingCodes: data => {
      dispatch(UserManagementAction.editUserAccountingCodes(data));
    },
    getAccountingCodes: data => {
      dispatch(UserManagementAction.getUserAccountingCodes(data));
    }
  };
};

const Index = reduxForm({
  form: "userAccountingCodeForm"
})(Form);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
